import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.parse-int.js";
import { EPermission } from '@/service/operate/comprehensiveDaily/type';
import { getMoneyEditPermission } from '@/service/operate/comprehensiveDaily/index';
export default function useMoneyEditPermission() {
  var permissionTag = ref(EPermission.no);
  var getMoneyEditPermissionAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getMoneyEditPermission();
          case 2:
            data = _context.sent;
            permissionTag.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getMoneyEditPermissionAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var hasPermission = computed(function () {
    return !!parseInt(permissionTag.value);
  });
  return [hasPermission, getMoneyEditPermissionAsync];
}